/* eslint-disable prefer-destructuring */
import { SagaMode } from './SagaMode';

export const DEFAULT_STORE_KEY = 'store';

/** @deprecated Please use {@link SagaMode} enum */
export const RESTART_ON_REMOUNT = SagaMode.RESTART_ON_REMOUNT;

/** @deprecated Please use {@link SagaMode} enum */
export const DAEMON = SagaMode.DAEMON;

/** @deprecated Please use {@link SagaMode} enum */
export const ONCE_TILL_UNMOUNT = SagaMode.ONCE_TILL_UNMOUNT;
